import React, { useCallback, useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import AddOrUpdateCourse from '../../components/datagrid/course/AddOrUpdateCourse';
import { Paper } from '@mui/material';
import GlobalDatagrid from '../../components/mui/DataGrid/GlobalDatagrid';
import { courseTableHeaderFn } from '../../components/datagrid/course/courseTableHeader';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCourses, getAllProjects } from '../../redux/features/courseSlice';
import ActionDetails from '../../components/mui/GlobalAnchor/ActionDetails';
import GlobalAnchorList from '../../components/mui/GlobalAnchor/GlobalAnchorList';
import DeleteCourse from '../../components/datagrid/course/DeleteCourse';
import ActiveOrInactiveButton from '../../components/datagrid/course/ActiveOrInactiveButton';
import ClickToShowImage from '../../components/datagrid/course/ClickToShowImage';
import { getSubjects } from '../../redux/features/croSlice';
import { getCourseCategories } from '../../redux/features/cartSlice';
import AddCourse from '../CSW/course_creation/AddCourse';
const Course = () => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search, rowData, openAnchor } = paginationData;
  const { resData, loading } = useSelector((store) => store.course);
  const { meta, courses } = resData;
  const [openAddCourseDescription, setOpenAddCourseDescript] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProjects());
    dispatch(getSubjects());
    dispatch(getCourseCategories());
  }, []);

  useEffect(() => {
    if (Object.keys(paginationData).length > 0) {
      const profile = JSON.parse(localStorage.getItem('cred'))?.profile;
      dispatch(getAllCourses({ ...paginationData, skillx: profile?.departmentId === 34 ? true : false }));
    }
  }, [gridSize, pageNum, search]);

  const courseTableHeader = useMemo(() => courseTableHeaderFn(setOpenAddCourseDescript), []);

  return (
    <GlobalWrapper title={'Course'} actions={<AddOrUpdateCourse />}>
      <Paper elevation={4}>
        <GlobalDatagrid
          tableHead={courseTableHeader}
          rows={courses || []}
          meta={meta?.totalRecords}
          rowUniqueId="id"
          loading={loading}
          rowClick={true}
          actionComponent={
            <>
              {openAnchor ? (
                <>
                  <ActionDetails val={rowData?.courseName} />
                  <GlobalAnchorList label="Update" component={<AddOrUpdateCourse row={rowData} />} />
                  <GlobalAnchorList label="Delete" component={<DeleteCourse row={rowData} />} />
                  <GlobalAnchorList label="Course Image" component={<ClickToShowImage url={rowData?.img} />} />
                  <GlobalAnchorList
                    label="Status"
                    component={<ActiveOrInactiveButton status={rowData?.courseAvailability} id={rowData?.id} />}
                  />
                </>
              ) : null}
            </>
          }
        />
      </Paper>
      <AddCourse
        setOpen={setOpenAddCourseDescript}
        open={Boolean(openAddCourseDescription)}
        row={openAddCourseDescription}
      />
    </GlobalWrapper>
  );
};

export default Course;
